module.exports = __webpack_public_path__ + "media/images/saint martin-17d26e4f6853baa801cb3215a83cefdf.svg";